import React from "react";
import "./UnderConstruction.scss";
import Button from "../../Button/Button";

export default function UnderConstruction({ t }) {
  return (
    <div className="under-construction">
      <h1>{t("apartments_hero_title")}</h1>
      <h2>{t("apartments_hero_subtitle")}</h2>
      <p>{t("apartments_hero_description")}</p>
      <Button
        text={t("apartments_hero_button")}
        to={"/"}
        variant={"secondary"}
      />
    </div>
  );
}
